import { useLazyLoadQuery } from "react-relay"
import { graphql } from "relay-runtime"
import { useChEmergencyPhoneNumbersQuery as useChEmergencyPhoneNumbersQueryType } from "@/modules/patients/components/header/emergency-service/services/ch/__generated__/useChEmergencyPhoneNumbersQuery.graphql"

const chEmergencyPhoneNumbersQuery = graphql`
  query useChEmergencyPhoneNumbersQuery {
    ch_emergencyPhoneNumbers {
      id
      name
      phoneNumber
      postalCode
    }
  }
`

export const useChEmergencyPhoneNumbersQuery = () => {
  const { ch_emergencyPhoneNumbers } = useLazyLoadQuery<useChEmergencyPhoneNumbersQueryType>(
    chEmergencyPhoneNumbersQuery,
    {},
  )
  return ch_emergencyPhoneNumbers
}
